import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_RESOURCES } from './appointment-resource-settings.reducer';

const loadingIndicatorSelector = (appState: any) => appState[STORE_FEATURE_KEY_RESOURCES].loadingIndicator;
const appointmentResourcesSelector = (appState: any) => appState[STORE_FEATURE_KEY_RESOURCES].appointmentResources;
const hasResourcesSelector = (appState: any) => appState[STORE_FEATURE_KEY_RESOURCES].hasResources;

@Injectable()
export class AppointmentResourceSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectAppointmentResources(): Observable<Array<any>> {
        return this.store
            .pipe(select(appointmentResourcesSelector));
    }

    selectLoadingIndicatorStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingIndicatorSelector));
    }

    selectHasResourcesSelector(): Observable<boolean> {
        return this.store.pipe(select(hasResourcesSelector));
    }
}
